<template>
    <div>
        <vs-input v-validate="{regex: /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3} [0-9]{4}$/}" name="phone" v-mask="'(##) ##### ####'" class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border label="CELULAR" placeholder="(00) 9 9999 9999" v-model="cellphone" @change="changeInput($event.target.value)"></vs-input>
        <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
    </div>
</template>

<script>
import {mask} from 'vue-the-mask'
import {Validator} from 'vee-validate'

const dict = {
    custom : {
        phone : {
            regex : 'Preencha o número de celular corretamente'
        }
    }
}

Validator.localize('en', dict)

export default {
    directives : {mask},

    props : {
        number : {
            required : true
        }
    },

    data() {
        return {
            cellphone : ''
        }
    },

    mounted () {
        this.cellphone = this.number
    },

    methods : {
        changeInput(val) {
            this.$emit('change', val)
        }
    }
}
</script>